import React, { useState, useEffect} from 'react';
import API_BASE_URL from '../config';
import { useDebounce } from 'react'; // Custom or lodash hook
import { Container, Table, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import MainModal from "./subcomponents/MainModal";
import TableTD from "./subcomponents/TableTd";
import TableTDBatch from './subcomponents/TableTdBatch';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';

const CrystalDashboard = () => {
    const [tabactive, setTabactive] = useState("1");
    const [orders, setOrders] = useState([]);
    const [phaseorders, setPhaseorders] = useState([]);
    const [iseditable, setIseditable] = useState();
    const [iseditableid, setIseditableid] = useState("");
    const [editData, setEditData] = useState({});
    const [modalon,setModalon] = useState(false);
    const [modalitem,setModalitem] = useState(null);
    const [modalData, setModaldata] = useState({
        items:{},
        message:"Empty Message",
        modalcallback: ()=>{}
    });
    const [clickable, setClickable] = useState({});
    const [selectedid, setSelectedid] = useState([])
    const [showBatchRow, setShowBatchRow] = useState(false);
    const [batchaddition, setBatchaddition] = useState(true);
    const [animatingId, setAnimatingId] = useState({ id: null, direction: null });
    const [showalldelivered, setShowalldelivered] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const activephase = {
                    "1" : "Order Confirmed",
                    "2" : "Fabric Recieved",
                    "3" : "Embroidery",
                    "4" : "Stiching",
                    "5" : "Ready To Ship",
                    "6" : "Delivered",
                };


    const checkitems = {
        "1":{
            "Selling Price":"sellingprice"

        },
        "2":{
            "On Road Expense":"fabricsourcing",
            "Fabric":"fabric",
            "Fabric Dye":"fabricdye",
            "Dupatta":"dupatta",
            "Dupatta Dye":"dupattadye",
            "Fabric Dispatch":"fabricdispatch"
        },
        "3":{
            "Work":"work",
            "Unstitched Dispatch":"unstitcheddispatch"
        },
        "4":{
            "Stitching":"stitching",
            "Lases":"lases",
            "Stitched Dispatch":"stitcheddispatch"
        },
        "5":{
            "Packaging Cost":"packagingcost",
            "Package Dispatch":"packagedispatched"
        },
        "6":{
            "Selling Price":"sellingprice",
            "On Road Expense":"fabricsourcing",
            "Fabric":"fabric",
            "Fabric Dye":"fabricdye",
            "Dupatta":"dupatta",
            "Dupatta Dye":"dupattadye",
            "Fabric Dispatch":"fabricdispatch",
            "Work":"work",
            "Unstitched Dispatch":"unstitcheddispatch",
            "Stitching":"stitching",
            "Lases":"lases",
            "Stitched Dispatch":"stitcheddispatch",
            "Packaging Cost":"packagingcost",
            "Package Dispatch":"packagedispatched",
            "Courrier Fee":"courierfee"

        }
    };
    useEffect(() => {
            // Load initial data
            getorders();
            // getphaseorders();
        }, []);

        useEffect(() => {
            if (orders.length>0) {
                getphaseorders();
            }
        }, [tabactive,orders,showalldelivered,searchQuery]);

        useEffect(() => {
            // console.log(editData);
            // console.log(iseditable,iseditableid,clickable);
        }, [clickable]);

        useEffect(()=>{
            // console.log(selectedid,"selected id");
            const fieldname = iseditable?.slice(0, -5);
            // console.log(fieldname);

            const allRelevantIds = Array.from(new Set([
                ...Object.keys(clickable.custname || {}), 
                ...selectedid
            ]));

            const setids = allRelevantIds.reduce((acc, id) => {
                acc[id] = selectedid.includes(id) ? "clickable_cell" : "";
                return acc;
            }, {});

        setClickable({...clickable,
                custname:setids,
                articlename:setids,
                [fieldname]:setids,
            });
            
        },[editData,selectedid]);


        useEffect(() => {
            if (editData.fabricsourcingbatch<=0) {
                    setSelectedid([]);
            }
        }, [editData]);

    const getorders = async ()=>{
        try {
            const res = await fetch(`${API_BASE_URL}/ordershowa`);
            const data = await res.json();
            setOrders(data);
        } catch (error) {
            console.error("Orders Not Fetched in crystal dashboard",error);
        }
    };

        const getphaseorders =()=>{
                    const phaseorder = orders.filter(item => {
                    const query = searchQuery.toLowerCase().trim();
                    const custmrname = item.custname || '';
                    const artiname = item.articlename || '';
                    // const isInCurrentPhase = item.odrsts === activephase[tabactive];
                    if (tabactive === "6"){
                        if(showalldelivered){
                        };
                        if(!query){
                            return showalldelivered && item.odrsts === activephase[tabactive]? true : item.odrsts === activephase[tabactive] && item.delivered === false;
                        }else{
                            return (showalldelivered && item.odrsts === activephase[tabactive])&& (custmrname.toString().toLowerCase().includes(query) || artiname.toString().toLowerCase().includes(query))? true : (item.odrsts === activephase[tabactive] && item.delivered === false)&& (custmrname.toString().toLowerCase().includes(query) || artiname.toString().toLowerCase().includes(query));
                        }
                    }else{
                        if(!query){
                            return item.odrsts === activephase[tabactive];
                        }else{
                            return item.odrsts === activephase[tabactive] && (custmrname.toString().toLowerCase().includes(query) || artiname.toString().toLowerCase().includes(query));
                        }

                    }
                });
                    setPhaseorders(phaseorder);
                    console.log("getphaseorders called")
                
            };


    const handeltabswitch = (e) =>{
        setTabactive(e);
        getphaseorders(orders);
    };

    const handelnextphase = async (orderid, nextprev) => {
    // 1. Start the animation immediately
    setAnimatingId({ id: orderid, direction: nextprev });

    // 2. Wait for the animation to finish (500ms) before executing your logic
    setTimeout(async () => {
        setModalon(false);
        let phasevalue = 0;
        if (nextprev === "next") {
            phasevalue = Number(tabactive) + 1;
        } else {
            phasevalue = Number(tabactive) - 1;
        };

        const updatedData = {
            phase: phasevalue,
            odrsts: activephase[phasevalue],
            phasehistory: {
                changedfrom: tabactive,
                changedto: phasevalue,
                chandedat: new Date()
            }
        };

        try {
            const res = await fetch(`${API_BASE_URL}/updateorder/${orderid}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatedData)
            });

            if (res.ok) {
                console.log("phase updated", phasevalue);
                await getorders();
                // setTabactive(String(phasevalue)); // Keep or remove depending on if you want the tab to switch automatically
            }
        } catch (error) {
            console.log("phase not updated");
        } finally {
            // 3. Reset animation state so the UI is ready for the next action
            setAnimatingId({ id: null, direction: null });
        }
    }, 500); // This 500ms matches the CSS animation duration
};

    const handeleditbutton = async (field, item, pressby) => {
    // 1. Check if we are SUBMITTING a change
    if (iseditable === field && pressby === "btn") {
        console.log("Click by btn")
        
        // Safety: Only check "Same Value" for single items, not batch strings
        if (iseditableid !== "batch" && editData[field] === item[field]) {
            toast.warning(`Same as Previous Value`);
            setIseditable("");
            setIseditableid();
            return; // Exit early
        }

        // 2. Handle Batch Update
        if (iseditableid === "batch" && item === "batch") {
            if (Number(editData[iseditable]) === 0 || selectedid.length < 1) {
                toast.warning(selectedid.length < 1 ? "No item selected" : "Input is Zero");
                setIseditable("");
                setIseditableid();
            } else {
                try {
                    // Corrected Logic
                    const batchAmount = batchaddition 
                    ? Number((Number(editData[iseditable]) / (selectedid.length || 1)).toFixed(2)) 
                    : Number(Number(editData[iseditable] || 0).toFixed(2));
                    const fieldname = iseditable.slice(0, -5);
                    
                    const updates = selectedid.map(id => {
                        const originalItem = orders.find(o => o._id === id);
                        const currentValue = (batchaddition?Number(originalItem?.[fieldname] || 0):0);
                        return {
                            id: id,
                            newValue: currentValue + batchAmount
                        };
                    });

                    const response = await fetch(`${API_BASE_URL}/updateorder/batch`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ field: fieldname, updates })
                    });

                    if (response.ok) {
                        toast.success(`Batch update successful!`);
                        setIseditable("");
                        setSelectedid([]);
                        await getorders();
                        setEditData({});
                    } else {
                        toast.error("Batch update failed");
                    }
                } catch (error) {
                    toast.error("Server Error during batch update");
                }
            }
        } 
        // 3. Handle Single Entry Update
        else {
            try {
                const response = await fetch(`${API_BASE_URL}/updateorder/${item._id}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ [field]: editData[field] })
                });
                if (response.ok) {
                    toast.success(`${field} Updated successfully!`);
                    setIseditable("");
                    await getorders();
                    if(typeof getphaseorders === 'function') getphaseorders(orders);
                    setEditData({});
                } else {
                    toast.error("Server Error by Backend");
                }
            } catch (error) {
                toast.error("Server Error");
            }
        }
    } 
    // 4. Handle First Click (Enabling Edit Mode)
    else {
        if (iseditable === field && (iseditableid === item._id || iseditableid === "batch")) {
            console.log("already editing");
        } else {
            // If item is "batch", it doesn't have [field], so we default to 0
            const initialVal = item === "batch" ? 0 : Number(item[field] || 0);
            setEditData({ ...editData, [field]: initialVal });
            setIseditable(field);
            setIseditableid(item._id ? item._id : item); // sets to "batch" or ID
            setClickable({ ...clickable, index: "clickable_index" });
            setTimeout(() => {
        // Construct a specific ID selector based on your component's ID
        // For TableTD, we will add an id attribute: id={`${field}-${item._id}`}
        const targetId = item === "batch" ? `batch-${field}` : `${field}-${item._id}`;
        const targetInput = document.getElementById(targetId);
        
        if (targetInput) {
            targetInput.focus();
            // scrollIntoView can be aggressive on iOS, only use if necessary
            targetInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, 150);
            console.log("first click");
        }
    }
};

    const handelitemselect = (id) => {
    setSelectedid((previds) => 
        previds.includes(id)? previds.filter(item => item !== id): [...previds, id]// Add if missing
    );
    
    console.log("Toggled ID:", id);
};

const handleDelivered = async (order, field) => {
    const isMarkingDelivered = !order.delivered;
    const updatedDate = isMarkingDelivered ? new Date().toISOString() : order.deliveredat;

    // 1. Custom Modal Trigger (Assuming you implemented the generic modal from earlier)
    const confirmMessage = `Mark order for "${order.custname}" as ${isMarkingDelivered ? "delivered" : "pending"}?`;
    // setModalon(false);
    
    // Logic to wrap the update
    const performUpdate = async () => {
        // 2. Optimistic UI Update 
        // IMPORTANT: Use the SAME state variable that renders your list (e.g., setPhaseorders)
        // setPhaseorders(prevOrders => 
        //     prevOrders.map(item => 
        //         item._id === order._id 
        //             ? { ...item, [field]: isMarkingDelivered, deliveredat: updatedDate } 
        //             : item
        //     )
        // );

        try {
            const response = await fetch(`${API_BASE_URL}/update-order-status/${order._id}`, {
                method: "PUT",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    [field]: isMarkingDelivered,
                    deliveredat: updatedDate 
                })
            });

            if (response.ok) {
                toast.success(`Order marked as ${isMarkingDelivered ? 'Delivered' : 'Pending'}`);
                // 3. REMOVE the order from view instantly if your screen only shows 'Pending'
                // This prevents the "order not going off screen" issue
                setPhaseorders(prev => prev.filter(item => item._id !== order._id));
                
                // Optional: Only fetch if you need to sync other complex data
                // await getphaseorders(); 
            } else {
                throw new Error();
            }
        } catch (error) {
            // 4. Rollback
            // setPhaseorders(prevOrders => 
            //     prevOrders.map(item => 
            //         item._id === order._id 
            //             ? { ...item, [field]: order.delivered, deliveredat: order.deliveredat } 
            //             : item
            //     )
            // );
            toast.error("Server update failed. Reverting status.");
        }
    };

    // If using window.confirm:
    if (true) {
        performUpdate();
    }
    // If using custom modal: requestConfirmation(confirmMessage, performUpdate);
};


const onmodal = (item,modalfunction)=>{
    // console.log(item)
const zeroitems = checkzeroitems(item);
console.log(zeroitems);
    const activeFields = zeroitems.filter(field => field && field.trim() !== "");

    const modalItemsObject = {};
    const zeroFieldLabels = [];

    // 2. Direct mapping over zeroitems to populate the object and message list
    activeFields.forEach(field => {
        // Format the raw key into a clean label (e.g., "selling_price" or "sellingPrice" -> "Selling Price")
        const formattedLabel = field.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').trim();
        const cleanLabel = formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);

        // Assign the exact item value (which will be 0) to your object
        // console.log(field);
        modalItemsObject[cleanLabel] = item[field];
        zeroFieldLabels.push(cleanLabel);
    });
    const dynamicMessage = `All these fields are Zero`;

    // const modalmessage = `${zeroitems[0]},${zeroitems[1]},${zeroitems[2]},${zeroitems[3]} and ${zeroitems.length - 4} other fields are Zero for ${item.custname}'s Order, want to continue?`;
    const modalmessage = dynamicMessage;
    setModaldata({
        items: modalItemsObject,
        message:modalmessage,
        modalcallback:modalfunction,
        modalitem:item
    });
    setModalitem(item);
    if(zeroitems.length>0){
        setModalon(true);
    }else{
        modalfunction();
    }

};

const closemodal = ()=>{
    setModalon(false);
}

const onmodalinfo = (item, modalfunction) => {
    // 1. Map entries directly into a clean, readable list string
    const modalmessage = `${item.custname}'s ${item.articlename}`;

    // 2. Dynamically build the items object with keys and values
    const modalItemsObject = {};
    Object.entries(checkitems[6] || {}).forEach(([key, value]) => {
        modalItemsObject[key] = item[value];
    });

    // 3. Pass both the built object and the message into the state
    setModaldata({
        items: modalItemsObject, // Stores { key1: item[value1], key2: item[value2], ... }
        message: modalmessage,
        modalcallback: modalfunction,
        modalitem:item
    });
    
    setModalitem(item);
    setModalon(true);
};
// const diffInMs = (item)=>{
//     return(
//         new Date(item.dateofdelivery) - new Date();
//     );
// } 

const checkzeroitems = (item)=>{
    const zeros = [];
    console.log(checkitems["1"])
    Object.entries(checkitems[item.phase]).map(([key,value])=>{
        if(item[value] == 0){
            console.log(value,"Zero item = ",item[value] );
            zeros.push(value)
        }
        else{
            // console.log(value,"Non Zero",item[value]);
        };
    });
    return zeros;
}

        const tabletdprops = {
        iseditable,
        iseditableid,
        editData,
        setEditData,
        handeleditbutton,
        clickable,
        selectedid,
        setIseditable,
        setIseditableid,
        batchaddition,
        setBatchaddition
    };

  return (
    <div className="container-fluid py-4 bg-light min-vh-100">
      <ul className="nav nav-pills nav-fill nav nav-pills nav-fill p-1 bg-white shadow-sm rounded-pill border phasetabs">
        {["Order Confirmed", "Fabric Sourcing", "Embroidery", "Stitching", "Packaging", "Delivery"].map((label, i) => (
        <li className="nav-item px-1" key={i}>
          <a
            className={`nav-link rounded-pill py-2 fw-semibold transition-all ${tabactive === `${i + 1}` ? "active bg-dark text-white" : "text-secondary hover-bg-light"}`}
            href="#"
            onClick={() => handeltabswitch(`${i + 1}`)}
          >
            <small className="d-block text-uppercase" style={{ fontSize: '0.65rem', opacity: 0.7 }}>Phase 0{i + 1}</small>
            <div className="d-flex justify-content-center gap-2">
            {label}
            
            {/* Toggle appears only on the Delivery pill when it is active */}
            {label === "Delivery"&& tabactive ==="6" && (
              <div 
                className="form-check form-switch m-0" 
                onClick={(e) => e.stopPropagation()} // Prevents tab switch when clicking toggle
              >
                <input 
                  className="form-check-input shadow-none" 
                  type="checkbox" 
                  role="switch"
                  checked={showalldelivered}
                  style={{ cursor: 'pointer', width: '1.8em', height: '0.9em' }}
                  onChange={(e) => {
                    setShowalldelivered(!showalldelivered);
                    // Call your specific logic for showing all delivered items here
                    console.log("Show All Delivered:", showalldelivered);
                  }}
                />
              </div>
            )}
          </div>
          </a>
        </li>
      ))}
    </ul>


    
        
    <Container className="container-fluid px-lg-4 mt-4">
        <div className="d-flex justify-content-end mb-3" role="search">
    <input 
        className="form-control" 
        type="search" 
        placeholder="Search..." 
        aria-label="Search" 
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ 
            width: "100%", 
            maxWidth: window.innerWidth < 768 ? "100%" : "440px" 
        }}
    />
</div>
    <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
      <div className="table-scroll-container">
      <Table className="table-hover mb-0 align-middle">
        <thead className="bg-dark text-white sticky-heade">
          <tr className='border-0 border-bottom'>
            {["1","2","3","4","5","6"].includes(tabactive) &&<th className="ps-4 py-3 border-0 align-middle">
      <div className="d-flex align-items-center">
        <span className="me-2">Sr.</span>
        {/* The Toggle Switch */}
        <div className="form-check form-switch ms-2">
          <input 
            className="form-check-input" 
            type="checkbox" 
            role="switch" 
            id="batchToggle"
            checked={showBatchRow}
            onChange={() => setShowBatchRow(!showBatchRow)}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>
    </th>}
            {["1","2","3","4","5","6"].includes(tabactive) &&<th className='py-3 border-0'>Customer</th>}
            {/* {["1","2","3","4","5","6"].includes(tabactive) &&<th className='py-3 border-0 text-nowrap'>Article</th>} */}
            {["1"].includes(tabactive) &&<th className="py-3 border-0">Price</th>}
            {["1"].includes(tabactive) &&<th className="py-3 border-0">Order Date</th>}
            {["1"].includes(tabactive) &&<th className="py-3 border-0 text-center">Delivery Date</th>}
            {["2"].includes(tabactive) &&<th className="py-3 border-0">On Road</th>}
            {["2"].includes(tabactive) &&<th className="py-3 border-0">Fabric</th>}
            {["2"].includes(tabactive) &&<th className="py-3 border-0">Fabric Dye</th>}
            {["2"].includes(tabactive) &&<th className="py-3 border-0">Dupatta</th>}
            {["2"].includes(tabactive) &&<th className="py-3 border-0">Dupatta Dye</th>}
            {/* {["2"].includes(tabactive) &&<th className="py-3 border-0">Lining</th>} */}
            {["2"].includes(tabactive) &&<th className="py-3 border-0">Fabric Dispatch</th>}
            {["3"].includes(tabactive) &&<th className="py-3 border-0">Work</th>}
            {["3"].includes(tabactive) &&<th className="py-3 border-0">Unstitched Dispatch</th>}
            {["4"].includes(tabactive) &&<th className="py-3 border-0">Stiching Cost</th>}
            {["4"].includes(tabactive) &&<th className="py-3 border-0">Lases & Other</th>}
            {["4"].includes(tabactive) &&<th className="py-3 border-0">Stitched Dispatch</th>}
            {["5"].includes(tabactive) &&<th className="py-3 border-0">Packaging Cost</th>}
            {["5"].includes(tabactive) &&<th className="py-3 border-0">Package Dispatch</th>}
            {["6"].includes(tabactive) &&<th className="py-3 border-0">Courier Fee</th>}
            {["6"].includes(tabactive) &&<th className="py-3 border-0">Tracking ID</th>}
            {["6"].includes(tabactive) &&<th className="py-3 border-0">Delivered Status</th>}
            {["1","2","3","4","5","6"].includes(tabactive) &&<th className='pe-4 py-3 border-0 text-end'>Action</th>}
          </tr>

          {showBatchRow && (<tr className='bg-light border-top border-bottom'>
            {["1","2","3","4","5","6"].includes(tabactive) &&<th className='ps-4 py-2 border-0'>
                <div className="d-flex align-items-center gap-2 mb-0">
    <label 
        htmlFor="batchToggle" 
        className="text-muted fw-bold mb-0" 
        style={{ fontSize: '10px', letterSpacing: '0.5px', textTransform: 'uppercase', cursor: 'pointer' }}
    >
        Batch Addition
    </label>
    <div className="form-check form-switch m-0 p-0">
        <input 
            className="form-check-input m-0 blue-switch" 
            type="checkbox" 
            role="switch" 
            id="batchToggle"
            checked={batchaddition}
            onChange={() => setBatchaddition(!batchaddition)}
            style={{ cursor: 'pointer', float: 'none', width: '1.8em', height: '1em' }}
        />
    </div>
</div>
            </th>}
            {/* {["1","2","3","4","5","6"].includes(tabactive) &&<th className='py-2 border-0'></th>} */}
            {["1","2","3","4","5","6"].includes(tabactive) &&<th className='py-2 border-0'></th>}
            {["1"].includes(tabactive) &&<th className='py-2 border-0'>Price</th>}
            {["1"].includes(tabactive) &&<th className='py-2 border-0'>Order Date</th>}
            {["1"].includes(tabactive) &&<th className='py-2 border-0'>Delivery Date</th>}
            {["2"].includes(tabactive) &&
                        <TableTDBatch
                            field = "fabricsourcingbatch"
                            {...tabletdprops}

                        />}

            {["2"].includes(tabactive) &&
                        <TableTDBatch
                            field = "fabricbatch"
                            {...tabletdprops}

                        />}
            {["2"].includes(tabactive) &&
                        <TableTDBatch
                            field = "fabricdyebatch"
                            {...tabletdprops}

                        />}
            {["2"].includes(tabactive) &&
                        <TableTDBatch
                            field = "dupattabatch"
                            {...tabletdprops}

                        />}
            {["2"].includes(tabactive) &&
                        <TableTDBatch
                            field = "dupattadyebatch"
                            {...tabletdprops}

                        />}
            {/* {["2"].includes(tabactive) &&
                        <TableTDBatch
                            field = "liningbatch"
                            {...tabletdprops}

                        />} */}
            {["2"].includes(tabactive) &&
                        <TableTDBatch
                            field = "fabricdispatchbatch"
                            {...tabletdprops}

                        />}
            {["3"].includes(tabactive) &&
                        <TableTDBatch
                            field = "workbatch"
                            {...tabletdprops}

                        />}
            {["3"].includes(tabactive) &&
                        <TableTDBatch
                            field = "unstitcheddispatchbatch"
                            {...tabletdprops}

                        />}
            {["4"].includes(tabactive) &&
                        <TableTDBatch
                            field = "stitchingbatch"
                            {...tabletdprops}

                        />}
            {["4"].includes(tabactive) &&
                        <TableTDBatch
                            field = "lasesbatch"
                            {...tabletdprops}

                        />}
            {["4"].includes(tabactive) &&
                        <TableTDBatch
                            field = "stitcheddispatchbatch"
                            {...tabletdprops}

                        />}
            {["5"].includes(tabactive) &&
                        <TableTDBatch
                            field = "packagingcostbatch"
                            {...tabletdprops}

                        />}
            {["5"].includes(tabactive) &&
                        <TableTDBatch
                            field = "packagedispatchedbatch"
                            {...tabletdprops}

                        />}
            {["6"].includes(tabactive) &&
                        <TableTDBatch
                            field = "courierfeebatch"
                            {...tabletdprops}

                        />}
            {["6"].includes(tabactive) &&<th className='py-2 border-0'>Tracking ID</th>}
            {["6"].includes(tabactive) &&<th className='py-2 border-0'>Delivered Status</th>}
            {["1","2","3","4","5","6"].includes(tabactive) &&<th className='py-2 border-0'></th>}
          </tr>)}

        </thead>
        <tbody className='datatablebody tablebodymain bg-white border-0'>
          {phaseorders.length>0?(phaseorders.map((item,index) => (
            <tr 
    className={`datatablerow tablebodyrow transition-all border-bottom border-light 
        ${editData[iseditable] > 0 && iseditableid === "batch" ? "disabled" : ""} 
        ${animatingId.id === item._id && animatingId.direction === "next" ? "exit-next" : ""} 
        ${animatingId.id === item._id && animatingId.direction === "prev" ? "exit-prev" : ""}`} key={item._id}>
              {["1", "2","3","4","5","6"].includes(tabactive) && <td className= {`align-middle ${clickable?.index}`}><div className="d-flex align-items-center justify-content-center gap-3"><button className="btn btn-edit-cool" onClick={() => window.location.href = `/update-order/${item._id}`} title="Edit Order"><i className="bi bi-pencil-fill"></i></button>
                {editData[iseditable]>0 && iseditableid=="batch"?<input className="form-check-input shadow-none" type="checkbox" value="" id="checkDefault" onChange={()=>handelitemselect(item._id)}/>:(<span className="text-muted">#{index + 1}</span>)}</div></td>}
              {["1", "2", "3", "4", "5", "6"].includes(tabactive) && (
                    <td className={`py-3 ${clickable?.custname?.[item._id]}`} onClick={()=>onmodalinfo(item,()=>closemodal())}>
                      <div className="d-flex flex-column justify-content-center">
                        {/* Primary Info: Customer Name */}
                        <span className="fw-bold text-dark mb-0" style={{ fontSize: '0.95rem', lineHeight: '1.2' }}>
                          {item.custname}
                        </span>

                        {/* Secondary Info: Article Name */}
                        <span className="text-muted fw-normal" style={{ fontSize: '0.75rem', marginTop: '2px' }}>
                          {item.articlename}
                        </span>
                      </div>
                    </td>
                )}
              {/* {["1", "2","3","4","5","6"].includes(tabactive) && <td className= {`text-dark small ${clickable?.articlename?.[item._id]}`}>{item.articlename}</td>} */}
              {/* {["1"].includes(tabactive) && <td><Badge bg="success">₹{item.sellingprice}</Badge></td>} */}
              {["1"].includes(tabactive) && <td className= {`py-2 ${clickable?.sellingprice?.[item._id]}`}><div className="input-group input-group-sm rounded-3 overflow-hidden shadow-sm border-0">
                    <input type="number" className="centerplaceholder form-control border-0 bg-light text-center fw-bold" aria-label="Selling Price" placeholder= "Selling Price" defaultValue={item.sellingprice} readOnly={iseditable!=="sellingprice" && iseditableid!==item._id} onClick={()=>handeleditbutton("sellingprice",item,"inpt")} onChange={(e)=>{setEditData({ ...editData, sellingprice: e.target.value })}}></input>
                    {iseditable==="sellingprice" && iseditableid===item._id ?<button className="btn btn-outline-secondary checkbtn btn-light" type="button" id="button-addon2" onClick={()=>handeleditbutton("sellingprice",item,"btn")}><i className="bi bi-check-lg"></i></button>:""}
                    </div></td>}
              {["1"].includes(tabactive) && <td className= {`small text-muted ${clickable?.dateoforder?.[item._id]}`}>{new Date(item.dateoforder).toLocaleDateString()}</td>}
              {["1"].includes(tabactive) && <td className={`text-center ${clickable?.dateofdelivery?.[item._id]}`}><div className="d-flex flex-column align-items-center">
                        <span className="small text-danger fw-bold mb-1">{new Date(item.dateofdelivery).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}</span>
                        {(() => {
                          const diffInMs = new Date(item.dateofdelivery) - new Date();
                          const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
                          let badgeClass = "text-bg-primary";
                          if (item.odrsts === "Delivered") badgeClass = "text-bg-success";
                          else if (diffInDays < 0) badgeClass = "text-bg-danger";
                          
                          const badgeText = item.odrsts === "Delivered" ? "Delivered" : diffInDays < 0 ? `Overdue ${Math.abs(diffInDays)}d` : `${diffInDays}d Left`;

                        //   return <span className={`badge rounded-pill ${badgeClass}`} style={{ fontSize: '0.65rem' }}>{badgeText}</span>;
                        })()}
                      </div></td>}
                    {["2"].includes(tabactive) &&
                        <TableTD
                            field = "fabricsourcing"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["2"].includes(tabactive) &&
                        <TableTD
                            field = "fabric"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["2"].includes(tabactive) &&
                        <TableTD
                            field = "fabricdye"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["2"].includes(tabactive) &&
                        <TableTD
                            field = "dupatta"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["2"].includes(tabactive) &&
                        <TableTD
                            field = "dupattadye"
                            item={item}
                            {...tabletdprops}

                        />}

                    {/* {["2"].includes(tabactive) &&
                        <TableTD
                            field = "lining"
                            item={item}
                            {...tabletdprops}

                        />} */}

                    {["2"].includes(tabactive) &&
                        <TableTD
                            field = "fabricdispatch"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["3"].includes(tabactive) &&
                        <TableTD
                            field = "work"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["3"].includes(tabactive) &&
                        <TableTD
                            field = "unstitcheddispatch"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["4"].includes(tabactive) &&
                        <TableTD
                            field = "stitching"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["4"].includes(tabactive) &&
                        <TableTD
                            field = "lases"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["4"].includes(tabactive) &&
                        <TableTD
                            field = "stitcheddispatch"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["5"].includes(tabactive) &&
                        <TableTD
                            field = "packagingcost"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["5"].includes(tabactive) &&
                        <TableTD
                            field = "packagedispatched"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["6"].includes(tabactive) &&
                        <TableTD
                            field = "courierfee"
                            item={item}
                            {...tabletdprops}

                        />}

                    {["6"].includes(tabactive) &&
                        <TableTD
                            field = "odrtrack"
                            item={item}
                            {...tabletdprops}

                        />}
                        
              {["6"].includes(tabactive) && (
  <td className={clickable?.delivered?.[item._id]}>
    <button
      type="button"
      /* Dynamic classes: change from 'outline-secondary' to 'success' when delivered */
      className={`btn btn-sm rounded-pill px-3 transition-all ${
        item.delivered ? "btn-success" : "btn-outline-secondary"
      }`}
      onClick={() => onmodal(item, () => handleDelivered(item,"delivered"))}
      style={{ minWidth: "100px", fontSize: '0.75rem' }}
    >
      {item.delivered ? (
        <>
          <i className="bi bi-check-circle-fill me-1"></i> Delivered<br/>
          <span className="text-white fw-small small" style={{ fontSize: '0.55rem' }}>
  {new Date(item.deliveredat).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: '2-digit'
  })}
</span>
        </>
      ) : (
        "Mark Delivered?"
      )}
    </button>
  </td>
)}


              {["1","2","3","4","5","6"].includes(tabactive) && <td className= {clickable?.nxtprevbtn?.[item._id]}>
                <div className='nxtprevbtn'>
                    {["2","3","4","5","6"].includes(tabactive) &&<button className= {`btn btn-sm btn-outline-secondary prevbtn ${tabactive==="1"?"disabled":""}`} onClick={() => onmodal(item, () => handelnextphase(item._id,"prev"))}>Previous</button>}
                    {["1","2","3","4","5"].includes(tabactive) &&<button className={`btn btn-sm btn-outline-success nxtbtn  ${tabactive==="6"?"disabled":""}`} onClick={()=>onmodal(item, () => handelnextphase(item._id,"next"))}>Next</button>}
                </div>
               {(() => {
                    const diffInMs = new Date(item.dateofdelivery) - new Date();
                    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

                    // 1. Determine the badge color
                    let badgeClass = "text-bg-primary"; // Default (Future date)
                    if (item.odrsts === "Delivered") {
                        badgeClass = "text-bg-success"; // Green for Delivered
                    } else{
                        if (diffInDays < 0){
                            badgeClass = "text-bg-danger";
                        }
                    }
                
                    // 2. Determine the text to show
                    const badgeText = item.odrsts === "Delivered" 
                        ? "Delivered" 
                        : diffInDays < 0 
                            ? `Overdue by ${Math.abs(diffInDays)}d` 
                            : `${diffInDays} Days Left`;
                
                    return (
                        <span className={`nxtprevbadge badge ${badgeClass}`}>
                            {badgeText}
                        </span>
                    );
                })()}
                
              </td>}
            </tr>
          ))):<tr className="no-data-row">
  <td colSpan="12" className="py-5 border-0 text-center">
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      {/* Subtle, elegant icon */}
      <div className="mb-3">
        <i className="bi bi-box-seam text-muted" style={{ fontSize: '3.5rem', opacity: '0.3' }}></i>
      </div>
      
      {/* Messaging */}
      <h5 className="fw-bold text-dark mb-1">No Orders Found</h5>
      <p className="text-muted small mb-4">
        It looks like there are no orders in this phase at the moment.
      </p>

      {/* Optional: Refresh or Reset Button */}
      <button 
        className="btn btn-sm btn-outline-dark rounded-pill px-4"
        onClick={() => getorders()}
      >
        <i className="bi bi-arrow-clockwise me-2"></i>
        Refresh Dashboard
      </button>
    </div>
  </td>
</tr>}
        </tbody>
      </Table>
      </div>
      </div>
    </Container>

    <MainModal
    isopen={modalon}
    onclose={() => setModalon(false)}
    items={modalData.items}
    modalitem={modalData.modalitem}
    message = {modalData.message}
    okfunction = {() => {
        modalData.modalcallback();
        setModalon(false);
    }
    }
    />

    </div>
  );
};
export default CrystalDashboard;